import { get } from '@util/xhrAPI'

const extensions = {
  pdf: {
    fileType: 'application/pdf',
    fileExetnsion: '.pdf'
  },
  csv: {
    fileType: 'text/plain;charset=utf-8',
    fileExetnsion: '.csv'
  }
}

const useDownloadFile = () => {
  const downloadFile = (fileUrl, fileName, extension) => {
    const { fileType, fileExetnsion } = extensions[extension]
    get(fileUrl, response => {
      const blob = new Blob([response], { type: fileType })
      const url = window.URL.createObjectURL(blob)
      const tempLink = document.createElement("a")
      tempLink.href = url
      tempLink.setAttribute(
        "download",
        `${fileName}${fileExetnsion}`
      )
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      window.URL.revokeObjectURL(url)
    }, false, 'arraybuffer')
  }

  return downloadFile
}

export default useDownloadFile